import React from "react";
import cns from "classnames";

import { Grid, TextField, createStyles, withStyles } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "react-icons/lib/md/search";
import ClearIcon from "react-icons/lib/md/clear";

import locale from "@bonliva-crm/locale";
import { ThemeType, WithStyles } from "@theme";
import { SearchType } from "./SearchType";

type Props = {
  className?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
  onSearchTypeChange?: (value: "basic" | "extended") => void;
  searchType?: string;
  value?: string;
  withSearchType?: boolean;
  withBorder?: boolean;
  disableAutocomplete?: boolean;
} & WithStyles<typeof styles>;

const Searchbar: React.FC<Props> = ({ classes, withBorder = true, ...props }) => {
  const handleChange = props.onChange;

  return (
    <Grid
      item
      className={cns(classes.topbar, props.className, {
        [classes.topbarWithBorder]: withBorder
      })}
    >
      <Grid container spacing={0} alignItems="center">
        <Grid item>
          <IconButton>
            <SearchIcon />
          </IconButton>
        </Grid>

        <Grid item className={classes.searchCell}>
          <TextField
            className={classes.textField}
            disabled={props.disabled}
            fullWidth
            autoComplete={props.disableAutocomplete ? "off" : "on"}
            name="text"
            placeholder={locale.Search}
            onChange={(e) => handleChange(e.target.value)}
            InputProps={{
              disableUnderline: true,
              endAdornment: props.withSearchType ? (
                <SearchType
                  value={props.searchType}
                  className={classes.searchType}
                  onChange={props.onSearchTypeChange}
                />
              ) : null
            }}
            inputProps={{
              "data-test": "Searchbar"
            }}
            value={props.value}
          />
        </Grid>

        <Grid item>
          <IconButton onClick={() => handleChange("")} disabled={props.disabled}>
            <ClearIcon />
          </IconButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

const styles = (theme: ThemeType) =>
  createStyles({
    topbar: {
      borderRadius: theme.radius,
      width: "100%",
      zIndex: 3,

      "&:not(:last-child)": {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
      }
    },

    topbarWithBorder: {
      "& > div": {
        borderBottom: `2px solid ${theme.palette.grey[500]}`
      }
    },

    searchCell: {
      flex: 1,
      fontWeight: "bold"
    },

    textField: {
      "& > div": {
        alignItems: "center"
      }
    },

    searchType: {
      alignItems: "center",
      fontSize: "90%"
    }
  });

export default withStyles(styles)(Searchbar);
